import { PropsWithChildren } from "react";
import { MDXPagesLayout } from "./mdx-pages";
import { PageProps } from "gatsby";
import { TopPanel } from "../shared/components/layout/top-panel";

export const CommonLayout = ({
  props,
  children,
}: PropsWithChildren<{
  props: PageProps;
}>) => {
  const { pathname } = props.location;

  const isMDXPage =
    pathname.startsWith("/pages") || pathname.startsWith("/privacy-policy");
  return (
    <>
      <TopPanel />
      {isMDXPage ? (
        <MDXPagesLayout props={props}>{children}</MDXPagesLayout>
      ) : (
        children
      )}
    </>
  );
};
